/* eslint-disable react/prop-types */
import { ButtonGroup, Card, Heading, Shelf, Stack, Text } from '@chaser/components';
import React from 'react';
import InfoLink from '../InfoLink';

const CardSection = ({
  title,
  buttons,
  label,
  infoLink,
  infoLabel,
  subtitle,
  children,
  gap = 0,
  justifyContent,
  borderWidth,
  borderRadius,
  borderColor,
  appearance,
  intent,
  tokenColor,
  tokenFontColor,
  tokenText,
  ...rest
}) => {
  return (
    <Card
      p={['small', 'medium', 'large']}
      borderWidth={borderWidth}
      borderRadius={borderRadius}
      borderColor={borderColor}
      appearance={appearance}
      intent={intent}
      tokenColor={tokenColor}
      tokenFontColor={tokenFontColor}
      tokenText={tokenText}
      {...rest}
    >
      <Stack gap={['small', gap]} as="section">
        <Shelf
          justifyContent="space-between"
          alignItems="flex-start"
          flexWrap={['wrap', 'nowrap']}
          minHeight={40}
        >
          <Shelf justifyContent={justifyContent} width={'100%'}>
            {typeof title === 'string' ? (
              <Heading
                data-testid={`title_${title}`}
                data-trackingid={`title_${title}`}
                as="h1"
                fontSize="heading.3"
                fontWeight="bold"
              >
                {title}
              </Heading>
            ) : (
              title
            )}
            {infoLink && <InfoLink to={infoLink} label={infoLabel} />}
            {label && <Text color="Mid Neutral 1">{label}</Text>}
            {subtitle && subtitle}
          </Shelf>
          <ButtonGroup flex="0 0 auto">{buttons}</ButtonGroup>
        </Shelf>
        <div>{children}</div>
      </Stack>
    </Card>
  );
};

export default CardSection;
